import React, { useContext } from "react";
import { Link, useNavigate, Outlet, useLocation } from "react-router-dom";
import { UserContext } from "../../../UserContext";
import Logo from "../../../../../../assets/images/user_app/menu_icons/despark_logo.svg";
import MissionsIcon from "../../../../../../assets/images/user_app/menu_icons/missions_icon.svg";
import MissionsIconActive from "../../../../../../assets/images/user_app/menu_icons/missions_icon_white.svg";
import InterviewsIcon from "../../../../../../assets/images/user_app/menu_icons/interviews_icon.svg";
import InterviewsIconActive from "../../../../../../assets/images/user_app/menu_icons/interviews_icon_white.svg";
import PayoutsIcon from "../../../../../../assets/images/user_app/menu_icons/payouts_icon.svg";
import PayoutsIconActive from "../../../../../../assets/images/user_app/menu_icons/payouts_icon_white.svg";
import ProfileIcon from "../../../../../../assets/images/user_app/menu_icons/profile_icon.svg";
import SmallProfileIcon from "../../../../../../assets/images/user_app/menu_icons/profile_small_icon.svg";
import BoosterIcon from "../../../../../../assets/images/user_app/menu_icons/booster_icon.svg";
import WalletsIcon from "../../../../../../assets/images/user_app/menu_icons/wallets_icon.svg";
import ReferralsIcon from "../../../../../../assets/images/user_app/menu_icons/referrals_icon.svg";
import AccountIcon from "../../../../../../assets/images/user_app/menu_icons/account_settings_icon.svg";

import LogoutIcon from "../../../../../../assets/images/user_app/menu_icons/logout_icon.svg";

import { useDisconnect } from 'wagmi'
import { useAlert } from 'react-alert';

import SessionAPI from "../../../preauth_portal/api/api_calls/sessionAPI"
const parseToInteger = (numStr) => {
    if (typeof numStr !== "string") {
        console.error("Invalid input: Expected a string");
        return null;
    }

    const num = parseFloat(numStr);

    if (isNaN(num)) {
        console.error("Invalid number format:", numStr);
        return null;
    }

    return Math.floor(num);
};

function PageLink(props) {
    const isActive = useLocation().pathname === props.page;
    const icon = isActive ? props.iconActive : props.icon;

    return (
        <Link to={{ pathname: props.page }} className={`nav-link mobile-nav-link text-white menu-link-div relative ${isActive ? "active" : ""}`}>
            <img src={icon} alt={props.name} className={`menu-icon ${isActive ? "active" : ""}`} />
            <div className={`menu-link-text ${isActive ? "active" : ""}`}>
                {props.name}
            </div>
            {props.balance && props.balance > 0 && props.balanceFormatted && (
                <div className="menu-link-balance">
                    <div className="menu-link-balance-text">
                        ${props.balanceFormatted}
                    </div>
                </div>
            )}
            {props.focusCircle && (
                <div className="menu-link-focus-circle"></div>
            )}
        </Link>
    )
}

function DropdownItem({ page, icon, name, onClick, focusCircle = false }) {
    return (
        <li className="dropdown-item dropdown-item-despark">
            {onClick ? (
                <button onClick={onClick} className="dropdown-item-interior no-underline logout-button-dropdown-item">
                    <img src={icon} alt={name} className="dropdown-menu-icon" />
                    <div className="dropdown-item-text body-small">{name}</div>

                </button>
            ) : (
                <Link to={{ pathname: page }} className="dropdown-item-interior no-underline dropdown-item-relative">
                    <img src={icon} alt={name} className="dropdown-menu-icon" />
                    <div className="dropdown-item-text body-small">{name}</div>
                    {focusCircle && (
                        <div className="dropdown-item-focus-circle"></div>
                    )}
                </Link>
            )}
        </li>
    );
}

function DropdownSeparator() {
    return (
        <div className="dropdown-item-separator"></div>
    )
}




function HeaderUser(props) {
    const { user, setUser, refreshUser } = useContext(UserContext);
    const { disconnect } = useDisconnect()
    const alert = useAlert();
    const navigate = useNavigate();

    // Let's adjust the username length based on screen size. 
    // If it's more than 8 characters, add a .. to the end regardless.
    // If it's 8 or less, but more than 6, and the screen size is less than 400, then show 5 characters and a ..
    // Otherwise, show the username.
    var userName = user.first_name;
    if (userName) {
        if (userName.length > 8) {
            userName = userName.substring(0, 8) + "..";
        } else if (userName.length > 6 && window.innerWidth < 400) {
            userName = userName.substring(0, 5) + "..";
        }
    }

    const balance = user.balance;
    const balanceFormatted = balance ? parseToInteger(balance) : "0";

    async function disconnectWallet() {
        await disconnect()
    }

    async function logout(event) {
        event.preventDefault();

        const response = await SessionAPI.destroy();

        if (response.success) {
            disconnectWallet()
            refreshUser()

            navigate("/signin")
        } else {
            alert.show("Unable to log out, please contact info@despark.io", { type: 'error' })
        }
    }

    return (
        <>
            <header className="header-user-sticky">
                <nav className="navbar navbar-expand-md navbar-dark navbar-despark">
                    <div className="container-fluid full-height mx-0 px-0">
                        <Link to={{ pathname: "/missions" }} className="navbar-brand mx-0 px-0">
                            <img src={Logo} alt="despark logo" className="logo-image" />
                        </Link>
                        <div className="menu-main-links-div">
                            <PageLink name="Missions" page="/missions" icon={MissionsIcon} iconActive={MissionsIconActive} />
                            <PageLink name="Interviews" page="/interviews" icon={InterviewsIcon} iconActive={InterviewsIconActive} />
                            <PageLink name="Payouts" page="/payouts" icon={PayoutsIcon} iconActive={PayoutsIconActive} balance={balance} balanceFormatted={balanceFormatted} focusCircle={user.referral_reward && user.referral_reward.status == "signed_up"} />

                        </div>
                        <div className="nav-item dropdown">
                            <a
                                className="nav-link no-dropdown-arrow dropdown-toggle menu-profile-link-div d-flex align-items-center"
                                href="#"
                                role="button"
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                            >
                                {user.emphasize_referrals && (
                                    <div className="menu-name-focus-circle"></div>
                                )}
                                <div className="menu-link-text body-medium">
                                    {userName}
                                </div>
                                <img src={ProfileIcon} alt={userName} className="menu-profile-icon" />
                            </a>

                            <ul className="dropdown-menu dropdown-menu-end main-menu">
                                <DropdownItem name="Profile" page="/profile" icon={SmallProfileIcon} />
                                <DropdownSeparator />
                                <DropdownItem name="Profile boosters" page="/boosters" icon={BoosterIcon} />
                                <DropdownSeparator />
                                <DropdownItem name="My wallets" page="/wallets" icon={WalletsIcon} />
                                <DropdownSeparator />
                                {/* <DropdownItem name="Balance history" page="/balance-history" icon={BalanceHistoryIcon} />
                                <DropdownSeparator /> */}
                                {user.approved_for_referrals && (
                                    <>
                                        <DropdownItem name="Referrals" page="/referrals" icon={ReferralsIcon} focusCircle={user.emphasize_referrals} />
                                        <DropdownSeparator />
                                    </>
                                )}
                                <DropdownItem name="Account settings" page="/account-settings" icon={AccountIcon} />
                                {/* <DropdownSeparator />
                                <DropdownItem name="Notifications" page="/notifications" icon={NotificationsIcon} /> */}
                                <DropdownSeparator />
                                <DropdownItem name="Log out" icon={LogoutIcon} onClick={logout} />
                            </ul>
                        </div>
                    </div>
                </nav>

            </header>
            <Outlet />
        </>
    )
}

export default HeaderUser;